import { apiCall, ApiResponse } from "./apiClient";
import { VehicleMaintenanceDto } from "../models/vehicleMaintenance/vehicleMaintenance";

export interface GetVehicleMaintenancesParams {
    fromDate?: string;
    untilDate?: string;
    vehicleIds?: string[];
}

export const getVehicleMaintenances = async (
    params: GetVehicleMaintenancesParams,
    signal?: AbortSignal
): Promise<ApiResponse<VehicleMaintenanceDto[]>> => {
    return apiCall<VehicleMaintenanceDto[], GetVehicleMaintenancesParams>(
        "vehiclemaintenance",
        "GET",
        params,
        signal
    );
};

export const getVehicleMaintenance = async (
    id: string,
    signal?: AbortSignal
): Promise<ApiResponse<VehicleMaintenanceDto>> => {
    return apiCall<VehicleMaintenanceDto>(`vehiclemaintenance/${id}`, "GET", undefined, signal);
};

export const saveVehicleMaintenance = async (
    vehicleMaintenance: VehicleMaintenanceDto,
    signal?: AbortSignal
): Promise<ApiResponse<VehicleMaintenanceDto>> => {
    const isNew = !vehicleMaintenance.id;

    return apiCall<VehicleMaintenanceDto>(
        "vehiclemaintenance",
        isNew ? "PUT" : "POST",
        vehicleMaintenance,
        signal
    );
};
